export function loadFavouriteEventIds() {
  const favs = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.startsWith("favouriteEventId-")) {
      const id = key.replace("favouriteEventId-", "");
      favs.push(id);
    }
  }
  return favs;
}

export function autoRemoveExpiredFavouriteIds(store) {
  // To remove expired favouriteIds from localStorage.
  const currentDay = new Date();

  const yesterday = new Date(
    currentDay.getFullYear(),
    currentDay.getMonth(),
    currentDay.getDate()
  );

  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);

    if (key.startsWith("favouriteEventId-")) {
      const eventDateStr = localStorage.getItem(key);
      const eventDate = new Date(eventDateStr);

      eventDate.setHours(0, 0, 0, 0);

      if (eventDate < yesterday) {
        localStorage.removeItem(key);

        const idStr = key.replace("favouriteEventId-", "");
        store.commit("REMOVE_FAVOURITE_EVENT_ID", idStr);
      }
    }
  }
}
